import { UserProfile } from 'src/api/model/user-profile';
import { RequestBuilder } from 'src/api/common/request-builder';
// import { UserModule } from '@/store/modules/user'
// import { Pagable } from 'src/constants/pagable';
// import { RequestUtils } from 'src/utils/request-utils';
import { UserProfileForm } from 'src/api/model/form/user-profile-form';
import request from 'src/utils/request';

export class UserProfileApi {
  getCurrentUser(): Promise<UserProfile> {
    return request({
      url: '/api/users/current-user',
      method: 'get',
    }).then((response: any) => {
      const apiData = response?.data?.data || response?.data || response;

      const rawFeatures = apiData.roleInfo?.features;
      let roleDetail: Record<string, boolean> = {};

      try {
        if (Array.isArray(rawFeatures)) {
          // parse  List<String>
          roleDetail = rawFeatures.reduce((acc: any, code: string) => {
            if (code) acc[code] = true;
            return acc;
          }, {} as Record<string, boolean>);
        } else if (typeof rawFeatures === 'string') {
          // parse JSON string
          const parsed = JSON.parse(rawFeatures);
          if (Array.isArray(parsed)) {
            roleDetail = parsed.reduce((acc: any, code: string) => {
              if (code) acc[code] = true;
              return acc;
            }, {} as Record<string, boolean>);
          } else if (parsed && typeof parsed === 'object') {
            roleDetail = parsed;
          }
        } else if (rawFeatures && typeof rawFeatures === 'object') {
          roleDetail = rawFeatures as Record<string, boolean>;
        }
      } catch (e) {
        roleDetail = {};
      }

      return {
        id: apiData.id,
        username: apiData.username || '',
        fullName: apiData.fullName || '',
        gender: apiData.gender || '',
        birthDay: apiData.birthDate || apiData.birthDay || '',
        email: apiData.email || '',
        phone: apiData.phone || '',
        avatar: apiData.avatar || '',
        deptName: apiData.deptName || '',
        roleId: apiData.roleId || '',
        roleName: apiData.roleInfo?.name || apiData.roleName || '',
        deptId: apiData.unitId || apiData.deptId || '',
        myDeptIds: apiData.myDeptIds || [],
        userType: apiData.accountType || apiData.userType || '',
        accountType: apiData.accountType || '',
        deptIds: apiData.deptIds || [],
        roleDetail,
        idNo: apiData.idNo || '',
        address: apiData.address || '',
        taxCode: apiData.taxCode || '',
        contactName: apiData.contactName || '',
        isFirstLogin: !!apiData.isFirstLogin,
        vneidLinked:
          apiData.vneidLinked === true ||
          apiData.authProvider === 'DMDC' ||
          !!apiData.dmdcLinkedAt,

        createdDate: apiData.createdAt || apiData.createdDate || '',
        createdBy: apiData.createdBy || '',
        lastModifiedDate: apiData.updatedAt || apiData.lastModifiedDate || '',
        lastModifiedBy: apiData.updatedBy || apiData.lastModifiedBy || '',
        isDeleted: apiData.isDeleted ? String(apiData.isDeleted) : 'false',
      } as unknown as UserProfile;
    });
  }

  findById(id: string): Promise<UserProfile> {
    return new RequestBuilder<UserProfile>()
      .url(`/userProfile/${id}`)
      .findOne();
  }

  // loadUserDeptRoles(form: UserDeptRole, pagable: Pagable): Promise<UserDeptRole[]> {
  //   const params = RequestUtils.merge(
  //     form,
  //     RequestUtils.initPageableParams(pagable)
  //   )
  //   return new RequestBuilder<UserDeptRole>()
  //     .url('/userDeptRoleView')
  //     .config({ params: params })
  //     .findAll()
  // }

  save(form: UserProfileForm) {
    return new RequestBuilder<UserProfile>()
      .url('/member/userProfile')
      .data(form)
      .post();
  }

  update(id: string, form: UserProfileForm) {
    return new RequestBuilder<UserProfile>()
      .url(`/userProfile/${id}`)
      .data(form)
      .put();
  }

  delete(id: string) {
    return new RequestBuilder<UserProfile>()
      .url(`/userProfile/${id}`)
      .delete();
  }
  //
  // findAllRole(form: RoleSearchForm, pagable: Pagable): Promise<Role[]> {
  //   const params = RequestUtils.merge(
  //     form,
  //     RequestUtils.initPageableParams(pagable)
  //   )
  //   return new RequestBuilder<Role>()
  //     .url('/role')
  //     .config(params)
  //     .findAll()
  // }
}

export const userProfileApi = new UserProfileApi();
